var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('publice.privacy')))]),_c('SanitizedHtml',{attrs:{"htmlContent":_vm.content}}),_c('p',[_vm._v("本隐私政策介绍了我们如何收集、使用、披露和保护您的个人信息。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }